import {
  LimitType,
  LimitsInConstraintGroupFormValue,
  getLimitsInConstraintOperations,
} from '@occc/feat-limits';
import { getFulfillmentWindowOperations } from '@occc/feat-constraints';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { OfferFragment } from '@occc/graphql';
import { getCustomDataOperations } from '@occc-app/routes/Game/GameConfigureForm/utils/customDataOperations';

import { getOfferNameAndDescriptionUpdateOperations } from '@occc-app/routes/Offer/components/OfferConfigureForm/utils/offerNameAndDescriptionUpdateOperations';
import { getOfferFulfillmentPriorityUpdateOperations } from '@occc-app/offerHelpers/operations/getOfferFulfillmentPriorityUpdateOperations';
import { getEarningMechanismOperations } from './earningMechanismOperations';
import { getConstraintOperations } from './constraintOperations';

import { GameConfigureFormValues } from '../../types';
import { getOfferComponentType } from '../../../../offerHelpers/utils';

type GetConfigureOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: GameConfigureFormValues,
  dirtyFields: DirtyFieldsType,
) => Operation[];

export const getConfigureFormOperations: GetConfigureOperations = (
  offerId,
  offer,
  values,
  dirtyFields,
) => {
  if (!offer) return [];

  const { global } = values.awardCount;

  const awardCount: LimitsInConstraintGroupFormValue = {
    ...values.awardCount,
    isEnabled: true,
    global:
      global.limit === undefined
        ? { ...global, isEnabled: false }
        : { ...global, isEnabled: true, limit: global.limit },
  };

  const awardCountLimitsOperations = getLimitsInConstraintOperations(
    offerId,
    awardCount,
    dirtyFields,
    LimitType.AwardCount,
    { isTransactionFrequencyLimitSupported: false, offer },
  );
  const fulfillmentWindowOperations = getFulfillmentWindowOperations(
    offerId,
    values.fulfillmentWindow,
    dirtyFields,
  );
  const constraintOperations = getConstraintOperations(offer, getOfferComponentType(offer));

  const customDataOperations = getCustomDataOperations(offerId, offer, values);
  const earningMechanismOperations = getEarningMechanismOperations(offerId, offer, values);

  return [
    ...earningMechanismOperations,
    ...constraintOperations,
    ...awardCountLimitsOperations,
    ...fulfillmentWindowOperations,
    ...customDataOperations,
    ...getOfferNameAndDescriptionUpdateOperations(offerId, values, dirtyFields),
    ...getOfferFulfillmentPriorityUpdateOperations(offerId, values, dirtyFields),
  ];
};
